<template>
  <div class="footer">
    <div class="footer-inset">
      <div class="menu-list">
        <div
          class="menu"
          v-for="(n, index) in menuList"
          :key="index"
          @click="go(n.route)"
        >
          <span>{{ n.name }}</span>
        </div>
      </div>
      <div class="company-msg">
        <div>Copyright © 2020-2021 DIRECT PROVIDER CO., LIMITED</div>
        <div class="company-links">
          <div class="company-link">
            <span>
              <img :src="instagram" />
            </span>
            <span>
              <img :src="facebook" />
            </span>
            <span>
              <img :src="twitter" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { instagram, facebook , twitter } from '../../images/news/index'
export default {
  data () {
    return {
      instagram,
      facebook,
      twitter,
      menuList: [
        {
          name: '会社概要',
          route: '/corporate'
        },
        {
          name: 'プライパシーポリシー',
          route: '/yinsi'
        },
        {
          name: '利用約款',
          route: '/statute'
        },
        {
          name: '海外代理店',
          route: '/news?id=2'
        },
        {
          name: 'お問い合わせ',
          route: '/contact'
        }
      ]
    }
  },
  methods: {
    init () {
    },
    go(url){
      this.$router.push(url)
    }
  }
}
</script>
<style scoped>
.footer {
  width: 100%;
  background: #121c1e;
  color: #fff;
  min-width: 1100px;
}
.footer-inset {
  width: 1100px;
  margin: 0 auto;
  padding: 50px 0;
}
.menu-list {
  margin: 0 auto;
  width: 720px;
  height: 80px;
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-size: 15px;
  font-family: A-OTF Gothic MB101 Pro;
  font-weight: normal;
  line-height: 32px;
}
.menu {
  /* flex: 1; */
  display: block;
  /* justify-self: ; */
}
.menu span {
  cursor: pointer;
}
.company-msg {
  font-size: 11px;
  font-family: A-OTF Gothic MB101 Pro;
  font-weight: normal;
  line-height: 16px;
  opacity: 0.5;
  font-weight: normal;
  font-size: 12px;
  display: flex;
}
.company-msg div {
  flex: 1;
}
.company-link {
  text-align: right;
  font-size: 25px;
}
.company-link span {
  cursor: pointer;
  display: inline-block;
  margin-left: 10px;
  color: #aaa;
}
.company-link span:active {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/public-modules/footer/index.vue